import React from 'react'
import ListMenu from '../../../../components/organisms/admin/menu/special/ListMenu'

type Props = {}

const ListMenuPage = (props: Props) => {
  return (
    <ListMenu />
  )
}

export default ListMenuPage